import { render, staticRenderFns } from "./GmBanner.vue?vue&type=template&id=1bed72e6&"
import script from "./GmBanner.vue?vue&type=script&lang=js&"
export * from "./GmBanner.vue?vue&type=script&lang=js&"
import style0 from "./GmBanner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports